import type { EfficiencyAnalysisRow, ExtraAnalysisRow, MenuSalesRow } from './state/dish-data-shared.types';

/**
 * 将菜单销售分析行序列化为 AI 摘要接口的 `payload.list` 元素。
 * 去掉 `quantity_curve`（折线图数据体积大），并剥离前端 `rowKey`、`totalMaxRate`。
 * @param rows - 当前表格行（可与搜索过滤结果一致）
 * @returns 可 JSON 序列化的列表项
 */
export function toMenuSalesAiSummaryListItems(rows: MenuSalesRow[]): Array<Record<string, unknown>> {
    return rows.map((row) => {
        /** 浅拷贝后删除不参与 AI 的字段，避免解构产生 eslint no-unused-vars */
        const payloadItem = { ...row } as Record<string, unknown>;
        delete payloadItem.rowKey;
        delete payloadItem.totalMaxRate;
        delete payloadItem.quantity_curve;
        return payloadItem;
    });
}

/**
 * 将额外费用分析行序列化为 AI 摘要接口的 `payload.list` 元素。
 * 去掉 `daily_curve`，并剥离前端 `rowKey`、`totalMaxRate`。
 * @param rows - 当前表格行（可与搜索过滤结果一致）
 * @returns 可 JSON 序列化的列表项
 */
export function toExtraFeeAiSummaryListItems(rows: ExtraAnalysisRow[]): Array<Record<string, unknown>> {
    return rows.map((row) => {
        const payloadItem = { ...row } as Record<string, unknown>;
        delete payloadItem.rowKey;
        delete payloadItem.totalMaxRate;
        delete payloadItem.daily_curve;
        return payloadItem;
    });
}

/**
 * 将出菜率分析行序列化为 AI 摘要接口的 `payload.list` 元素。
 * 剥离前端 `rowKey`、`totalMaxRate`。
 * @param rows - 当前表格行（可与搜索过滤结果一致）
 * @returns 可 JSON 序列化的列表项
 */
export function toEfficiencyAiSummaryListItems(rows: EfficiencyAnalysisRow[]): Array<Record<string, unknown>> {
    return rows.map((row) => {
        const payloadItem = { ...row } as Record<string, unknown>;
        delete payloadItem.rowKey;
        delete payloadItem.totalMaxRate;
        return payloadItem;
    });
}
